import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WorkflowConfigurationSaveAction, WorkflowConfigurationSaveListItem } from 'src/app/models';
import { WorkflowContextService, WorkflowService } from 'src/app/services';

@Component({
  selector: 'wm-pending-workflow-list',
  templateUrl: './pending-workflow-list.component.html',
  styleUrl: './pending-workflow-list.component.css',
  standalone: false
})
export class PendingWorkflowListComponent implements OnInit, OnDestroy {
  workflowSaves: WorkflowConfigurationSaveListItem[];
  clientSub: Subscription;
  loading = true;
  WorkflowConfigurationSaveAction = WorkflowConfigurationSaveAction;

  constructor(
    private _context: WorkflowContextService,
    private _workflowSvc: WorkflowService
  ) {}

  ngOnInit() {
    if (this._context && this._context.client) {
      this.getPendingWorkflows();
    } else {
      this.clientSub = this._context.client$.subscribe(() => {
        if (this._context.client) {
          this.getPendingWorkflows();
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
      this.clientSub = null;
    }
  }

  getPendingWorkflows() {
    this._workflowSvc.getPendingWorkflows(this._context.client.id)
      .subscribe(workflowSaves => {
        this.workflowSaves = workflowSaves || [];

        this.loading = false;
      })
  }

  deletePending(workflowSaveId: string) {
    this.loading = true;

    this._workflowSvc.deletePendingWorkflow(workflowSaveId)
      .subscribe(result => {
        if (result) {
          this.getPendingWorkflows();

          this.loading = false;
        }
      });
  }
}
